import script from "./LeftMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftMenu.vue?vue&type=script&setup=true&lang=js"

import "./LeftMenu.vue?vue&type=style&index=0&id=b6e9186e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6e9186e"]])

export default __exports__